import { Badge } from "@getgreenline/blaze-ui";
import { cn } from "@getgreenline/blaze-ui";

type CardBadgeProps = React.ComponentProps<typeof Badge>;

export function CardBadge({ className, ...props }: CardBadgeProps) {
  return (
    <Badge
      className={cn(
        "tw:shrink-0 tw:inline-flex tw:h-6 tw:items-center tw:justify-center tw:rounded-full tw:px-2.5 tw:py-0 tw:text-[10px] tw:font-medium tw:leading-none",
        className,
      )}
      {...props}
    />
  );
}
